import {v4 as uuidv4} from 'uuid'
import {LanguageTranslations} from '../config/language'

export interface CartItem {
  product_id: number
  uuid: string
  replace_name: string
  inputs: {[key: string]: string}
  product_name: string
  product_slug: string
  demo_name: string
  //cover: Cover
  cover?: Cover
  cover_id: number | null
  default_replace_name: string
  product_type: 1 | 2
  image: string
  price: number
  quantity: number
  total: number
  language?: keyof LanguageTranslations
  discount: number
  gender?: string
  dedication?: string
  dedication_id?: number
}

export interface Cover {
  id: number
  name: string
  price: number
  description: string
  image: string
  created_at: Date
  updated_at: Date
  pivot: Pivot
}

export interface Pivot {
  product_id: number
  covers_id: number
}

export type initialStateType = {
  uuid: string
  items: Array<CartItem>
  customer_id?: null | number
  address: any
  address_type: 'pickup_point' | 'home_delivery' | 'self_pickup'
  subtotal: number
  shipping_fee: number
  coupon: string | null
  coupon_type: 'shipping' | null
  coupon_percent: number
  discount_total: number
  total: number
}

export const initialState: initialStateType = {
  uuid: uuidv4(),
  customer_id: null,
  items: [],
  total: 0,
  subtotal: 0,
  address: null,
  address_type: 'self_pickup',
  coupon: null,
  coupon_type: null,
  coupon_percent: 0,
  discount_total: 0,
  shipping_fee: 0,
}

export type actionType =
  | {type: 'SET_CART'; payload: initialStateType}
  | {type: 'EMPTY_CART'}

export const CartReducer = (
  state: initialStateType,
  action: actionType,
): initialStateType => {
  // console.log('action', action)
  switch (action.type) {
    case 'SET_CART':
      return {...state, ...action.payload}

    case 'EMPTY_CART':
      localStorage.removeItem('basmti_cart_uuid')
      return {...initialState, uuid: uuidv4()}

    default:
      throw new Error(`Unhandled action type: ${action}`)
  }
}